<template>
  <div>
    <div class="c-mask" @click="$parent.showCats=false"></div>
    <div class="c-wrap">
      <div class="c-top">
        全部文章分类
        <span>（点击进入分类）</span>
        <a class="close" href="javascript:;" @click="close">
          <i class="iconfont icon-guanbi"></i>
        </a>
      </div>
      <div class="c-box">
        <template v-for="(c) in cats" :key="c.id">
          <span :class="c.id == curCid ?'active' : ''" @click="$parent.changeCat(c.id)">{{c.name}}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cats: {
      type: Array,
      default: () => [],
    },
    curCid: {
      type: [Number, String],
      default: -1,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.c-mask {
  z-index: 11;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  bottom: 0;
  width: 750px;
  left: 50%;
  margin-left: -375px;
  right: 0;
  display: none;
}
.c-wrap {
  border-radius: 20px 20px 0px 0px;
  bottom: 0;
  margin-left: -375px;
  width: 750px;
  left: 50%;
  background: #fff;
  position: fixed;
  transform: translateY(120%);
  transition: transform 0.3s linear;
  z-index: 12;
}
.c-top {
  padding: 32px 32px 30px;
  font-size: 32px;
  font-weight: 500;
  color: #333333;
  line-height: 32px;
  border-bottom: 1px solid #eee;
  position: relative;
  span {
    font-size: 24px;
    font-weight: 500;
    color: #888888;
    line-height: 24px;
  }
  .close {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 32px;
    top: 32px;
    i {
      font-size: 28px;
    }
  }
}
.c-box {
  padding: 22px 32px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -9px;
  max-height: 900px;
  overflow: auto;
  span {
    flex: 156px 0 0;
    line-height: 70px;
    margin: 18px 10px;
    justify-content: center;
    font-size: 26px;
    font-weight: 500;
    color: #333333;
    background: #f6f6f6;
    border-radius: 10px;
    text-align: center;
    &.active {
      color: #f50;
    }
  }
}
.showBtm {
  .c-wrap {
    transform: translateY(0);
  }
  .c-mask {
    display: block;
  }
}
</style>